module.exports = __webpack_public_path__ + "img/id_card_face.aba2c4a3.png";